import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

interface LogoutAlertDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
}

const LogoutAlertDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: LogoutAlertDialogProps) => {
  const { t } = useTranslation();
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <AlertDialogContent
          w={{ base: "80vw", md: "100%" }}
          maxW={{ base: "80vw", md: "md" }}
        >
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t("profileMenu.logoutConfirmTitle")}
          </AlertDialogHeader>

          <AlertDialogBody>
            {t("profileMenu.logoutConfirmBody")}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={onClose}
              variant="ghost"
              mr={3}
              isDisabled={isLoading}
            >
              {t("common.cancel")}
            </Button>
            <Button colorScheme="red" onClick={onConfirm} isLoading={isLoading}>
              {t("profileMenu.logout")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default LogoutAlertDialog;
